import { z } from 'zod'

export const invitationDetailSchema = z.object({
  email: z.array(z.string())
})

export interface InvitationDetail
  extends z.infer<typeof invitationDetailSchema> {}
